import dispatcher from "./Dispatcher"
import axios from 'axios'
import AlertStore from './AlertStore';

function syncronizeAlerts() {

  if (AlertStore.getSave() != null && !(AlertStore.getSave()==="")) {
    const params = new URLSearchParams();
    params.append('target', AlertStore.getSave());
    axios({ 
    method: 'post',
    url: '/alerts',
    data: {
      target: AlertStore.getSave(),
      payload: JSON.stringify(AlertStore.getAll())
    },
    headers: {
      'content-type': 'application/json; charset=utf-16'
    }
  }).catch(function (error) {
    window.alert("This feature is not active, pls clear 'Storage Name / Email' field at the top right\n" + error);
  });
  }
}

  export function loadSave(save) {
    axios.get(window.location.href.toString() + "alerts" + "?" + "savename=" + save)
    .then(resp => {
      var data = eval(JSON.stringify(resp.data));
      dispatcher.dispatch({
        type: "REPLACE_ALERTS",
        alerts: data
      });
    })
    .catch(function (error) {
      window.alert("unable to load your storage");
    });
}

export function createAlert(data) {
  dispatcher.dispatch({
    type: "CREATE_ALERT",
    data
  });
  syncronizeAlerts();
}

export function shiftAlert(id, direction) {
  dispatcher.dispatch({
    type: "SHIFT_ALERT",
    id,
    direction
  })
  syncronizeAlerts();
}

export function editAlert(alert) {
  dispatcher.dispatch({
    type: "EDIT_ALERT",
    alert,
  })
  syncronizeAlerts();
}

export function deleteAlert(id) {
  dispatcher.dispatch({
    type:"DELETE_ALERT",
    id
  })
  syncronizeAlerts();
}

export function visualizeAlert(alert) {
  dispatcher.dispatch({
    type:"VISUALIZE_ALERT",
    alert
  })
}

export function chartCoordinatesChanged(x,y) {
  dispatcher.dispatch({
    type:"COORDINATES_CHANGED",
    x,
    y
  })
}

export function chartCoordinatesSelected() {
  dispatcher.dispatch({
    type:"COORDINATES_SELECTED",
  })
}

export function setSave(save) {
  dispatcher.dispatch({
    type:"SET_SAVE",
    save
  })
}
